import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://bifsztsuzydthpqrltgm.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJpZnN6dHN1enlkdGhwcXJsdGdtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQwNTE5ODgsImV4cCI6MjA4OTYyNzk4OH0.3RRPFKKU9yyr-T3HC1TDFVdvnJbTa2mGqXikhb1yBuM';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
